module.exports = __webpack_public_path__ + "static/BasinBulteni_Efes2026_eng-3de3cdb632a4ad6f5c0c3e3e53f20f93.png";